import React from 'react'
import Header from '../../../../Components/Header'
import Footer from '../../../../Components/Footer'
import ViewWarehouseDeatil from './ViewWarehouseDeatil'
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const ViewBinmaster = () => {
      const location = useLocation();
  const warehouseData = location.state;
  return (

    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
            <Helmet>
				<title>Bin - View</title>
			</Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
        <ViewWarehouseDeatil warehouseData={warehouseData}/>
            </div>
        </div>
  )
}

export default ViewBinmaster